import React, { useState, useEffect } from 'react';

const Step2Address = ({ data, onChange, onNext, onBack }) => {
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (data.same_as_current) {
      onChange({
        permanent_address: data.current_address,
        permanent_city: data.current_city,
        permanent_state: data.current_state,
        permanent_pincode: data.current_pincode,
      });
    }
    // eslint-disable-next-line
  }, [data.same_as_current, data.current_address, data.current_city, data.current_state, data.current_pincode]);

  const handleChange = (field, value) => {
    onChange({ [field]: value });
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const validate = () => {
    const e = {};
    if (!data.current_address || data.current_address.trim().length < 5)
      e.current_address = 'Enter your full address';
    if (!data.current_city || data.current_city.trim().length < 2)
      e.current_city = 'City is required';
    if (!data.current_state || data.current_state.trim().length < 2)
      e.current_state = 'State is required';
    if (!data.current_pincode || !data.current_pincode.match(/^[1-9][0-9]{5}$/))
      e.current_pincode = 'Enter a valid 6-digit pincode';
    if (!data.same_as_current) {
      if (!data.permanent_address || data.permanent_address.trim().length < 5)
        e.permanent_address = 'Enter your full address';
      if (!data.permanent_city || data.permanent_city.trim().length < 2)
        e.permanent_city = 'City is required';
      if (!data.permanent_state || data.permanent_state.trim().length < 2)
        e.permanent_state = 'State is required';
      if (!data.permanent_pincode || !data.permanent_pincode.match(/^[1-9][0-9]{5}$/))
        e.permanent_pincode = 'Enter a valid 6-digit pincode';
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleNext = () => { if (validate()) onNext(); };

  return (
    <div className="ob-step">
      <div className="ob-step__header">
        <h2>Address Information</h2>
        <p>Provide your current and permanent residential address.</p>
      </div>

      {/* Current Address */}
      <div className="ob-section">
        <h3 className="ob-section__title">Current Address</h3>
        <div className="ob-grid ob-grid--2">
          <div className="ob-field ob-field--full">
            <label>Street Address <span className="ob-required">*</span></label>
            <textarea
              className={`ob-input ob-textarea ${errors.current_address ? 'ob-input--error' : ''}`}
              placeholder="House/Flat No., Street, Area, Landmark"
              rows="2"
              value={data.current_address}
              onChange={(e) => handleChange('current_address', e.target.value)}
            />
            {errors.current_address && <span className="ob-error">{errors.current_address}</span>}
          </div>
          <div className="ob-field">
            <label>City <span className="ob-required">*</span></label>
            <input type="text" className={`ob-input ${errors.current_city ? 'ob-input--error' : ''}`} placeholder="City" value={data.current_city} onChange={(e) => handleChange('current_city', e.target.value)} />
            {errors.current_city && <span className="ob-error">{errors.current_city}</span>}
          </div>
          <div className="ob-field">
            <label>State <span className="ob-required">*</span></label>
            <input type="text" className={`ob-input ${errors.current_state ? 'ob-input--error' : ''}`} placeholder="State" value={data.current_state} onChange={(e) => handleChange('current_state', e.target.value)} />
            {errors.current_state && <span className="ob-error">{errors.current_state}</span>}
          </div>
          <div className="ob-field">
            <label>Pincode <span className="ob-required">*</span></label>
            <input type="text" className={`ob-input ${errors.current_pincode ? 'ob-input--error' : ''}`} placeholder="600001" maxLength="6" value={data.current_pincode} onChange={(e) => handleChange('current_pincode', e.target.value.replace(/\D/g, ''))} />
            {errors.current_pincode && <span className="ob-error">{errors.current_pincode}</span>}
          </div>
        </div>
      </div>

      {/* Same as Current */}
      <label className="ob-checkbox">
        <input
          type="checkbox"
          checked={data.same_as_current}
          onChange={(e) => {
            onChange({ same_as_current: e.target.checked });
            if (e.target.checked) setErrors((prev) => ({ ...prev, permanent_address: '', permanent_city: '', permanent_state: '', permanent_pincode: '' }));
          }}
        />
        <span className="ob-checkbox__box"></span>
        <span className="ob-checkbox__text">Permanent address is same as current address</span>
      </label>

      {/* Permanent Address */}
      <div className={`ob-section ${data.same_as_current ? 'ob-section--disabled' : ''}`}>
        <h3 className="ob-section__title">Permanent Address</h3>
        <div className="ob-grid ob-grid--2">
          <div className="ob-field ob-field--full">
            <label>Street Address <span className="ob-required">*</span></label>
            <textarea className={`ob-input ob-textarea ${errors.permanent_address ? 'ob-input--error' : ''}`} placeholder="House/Flat No., Street, Area, Landmark" rows="2" value={data.permanent_address} onChange={(e) => handleChange('permanent_address', e.target.value)} disabled={data.same_as_current} />
            {errors.permanent_address && <span className="ob-error">{errors.permanent_address}</span>}
          </div>
          <div className="ob-field">
            <label>City <span className="ob-required">*</span></label>
            <input type="text" className={`ob-input ${errors.permanent_city ? 'ob-input--error' : ''}`} placeholder="City" value={data.permanent_city} onChange={(e) => handleChange('permanent_city', e.target.value)} disabled={data.same_as_current} />
            {errors.permanent_city && <span className="ob-error">{errors.permanent_city}</span>}
          </div>
          <div className="ob-field">
            <label>State <span className="ob-required">*</span></label>
            <input type="text" className={`ob-input ${errors.permanent_state ? 'ob-input--error' : ''}`} placeholder="State" value={data.permanent_state} onChange={(e) => handleChange('permanent_state', e.target.value)} disabled={data.same_as_current} />
            {errors.permanent_state && <span className="ob-error">{errors.permanent_state}</span>}
          </div>
          <div className="ob-field">
            <label>Pincode <span className="ob-required">*</span></label>
            <input type="text" className={`ob-input ${errors.permanent_pincode ? 'ob-input--error' : ''}`} placeholder="600001" maxLength="6" value={data.permanent_pincode} onChange={(e) => handleChange('permanent_pincode', e.target.value.replace(/\D/g, ''))} disabled={data.same_as_current} />
            {errors.permanent_pincode && <span className="ob-error">{errors.permanent_pincode}</span>}
          </div>
        </div>
      </div>

      <div className="ob-actions">
        <button className="ob-btn ob-btn--ghost" onClick={onBack}>Back</button>
        <button className="ob-btn ob-btn--primary" onClick={handleNext}>
          Continue
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7h8M8 4l3 3-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
      </div>
    </div>
  );
};

export default Step2Address;
